export var defaultOpts = {
    navCtrl: true,
    scaleCtrl: true,
    overviewCtrl: true,
    enableScrollWheelZoom: true,
    geolocationCtrl: false,
    zoom: 10
};
export var defaultOfflineOpts = {
    retryInterval: 30000,
    txt: 'OFFLINE'
};



//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/node_modules/angular2-baidu-map/dist/defaults.js
// module id = ../../../../angular2-baidu-map/dist/defaults.js
// module chunks = common